import { useState, useEffect, useLayoutEffect } from 'react';
import { MdError } from 'react-icons/md';
import '../RouteRules/RulesFormModal/RulesFormModal.scss';

interface ValidationErrorsProps {
  validationErrors: string[];
}

export const ValidationErrors = ({ validationErrors }: ValidationErrorsProps) => {
  const [scrollTop, setScrollTop] = useState(false);

  useLayoutEffect(() => {
    const formErrorsRulesEl = document.getElementById('form-errors');
    if (scrollTop && formErrorsRulesEl) {
      formErrorsRulesEl.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      setScrollTop(false);
    }
  }, [scrollTop]);

  useEffect(() => {
    if (validationErrors.length > 0) {
      setScrollTop(true);
    }
  }, [validationErrors]);

  if (validationErrors.length === 0) return null;

  return (
    <div id='form-errors' className='wto-info-box validations' data-testid='validation-errors'>
      <div className='icon'>
        <MdError />
      </div>
      <div className='message'>
        <span>Errors:</span>
        <ul>
          {validationErrors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
